import io from 'socket.io-client';

let socketInstance = null;

const getSocketInstance = () => {
	if (!socketInstance) {
		// Create the socket connection if it doesn't exist
		socketInstance = io('https://socket.prepseed.com');
		// socketInstance = io('http://localhost:4041');

		socketInstance.on('connect', () => {
			console.log('Socket connected');
			console.log(socketInstance.id);
		});

		// Add other event listeners and configurations here as needed

		// Clean up the socket connection on window unload
		window.addEventListener('beforeunload', () => {
			if (socketInstance) {
				socketInstance.disconnect();
				socketInstance = null;
			}
		});
	}

	return socketInstance;
};

export default getSocketInstance;
